module.exports = __webpack_public_path__ + "img/buy-eggs.1c0af203.svg";